import { InjectionToken, Signal } from '@angular/core'

export type AuthTokenStorageType = 'cookie' | 'local'

/**
 * Where auth tokens are persisted. Cookie storage shares the session across subdomains,
 * local storage keeps it scoped to the current origin.
 */
export const AUTH_TOKEN_STORAGE = new InjectionToken<Signal<AuthTokenStorageType>>('AUTH_TOKEN_STORAGE')
